const routeAdminRole = [
    "/inventoryManagement",
    "/customer",
    "/barcode/list",
    "/attendance",
    "/credit-ledger",
    // Prefix only — haveAccess() is called with the path minus the :vendorId param.
    "/vendor-debt",
    "/report/customer-credit-dashboard",
    "/report/vendor-debt-dashboard",
    // Feedback module carries customer PII (name, mobile, comments) — same
    // admin-only gate as the other PII-bearing dashboards above.
    "/report/feedback-dashboard",
    "/feedback/list",
    // Rent payments are admin-only, same as the other admin-group screens.
    "/rental",
]

export {
    routeAdminRole
}